import React from "react";
import RegisterShell from "../../components/register/RegisterShell";
import RegisterSidebar from "../../components/register/RegisterSidebar";
import RegisterHeader from "../../components/register/RegisterHeader";
import RegisterStepSummaryMobile from "../../components/register/RegisterStepSummaryMobile";
import { CadastroWizardScreen } from "./CadastroWizardScreen";
import { useCadastroWizard } from "./useCadastroWizard";

const CadastroPage: React.FC = () => {
  const wizard = useCadastroWizard();
  const { highLevelIndex, desktopProgress, stepTitles } = wizard;

  return (
    <RegisterShell>
      <RegisterSidebar
        stepTitles={stepTitles}
        highLevelIndex={highLevelIndex}
        desktopProgress={desktopProgress}
      />

      <div className="flex h-full flex-1 flex-col min-h-0">
        <RegisterHeader />

        <div className="flex-1 min-h-0 flex flex-col lg:max-w-3xl lg:w-full lg:self-center lg:border-x lg:border-gray-100 lg:dark:border-gray-800">
          <RegisterStepSummaryMobile
            currentIndex={highLevelIndex}
            totalSteps={stepTitles.length}
          />
          <CadastroWizardScreen wizard={wizard} />
        </div>
      </div>
    </RegisterShell>
  );
};

export default CadastroPage;
